// removed by extract-text-webpack-plugin
module.exports = {"TrdAdminFocus":"TrdAdminFocus__-loca-__SDtdu","TrdFocusGroup":"TrdAdminFocus__-loca-__3dI0b","ReturnButton":"TrdAdminFocus__-loca-__2pKp_","ReturnButtonHelper":"TrdAdminFocus__-loca-__1Bh3b","Spinner":"TrdAdminFocus__-loca-__3W0y0","FuncSpinner":"TrdAdminFocus__-loca-__1iZle","BottomLevel":"TrdAdminFocus__-loca-__3I4E0","Message":"TrdAdminFocus__-loca-__3ElkW","TrdGameButton":"TrdAdminFocus__-loca-__22UsK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/TrdAdminFocus/TrdAdminFocus.css
// module id = 212
// module chunks = 0